import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import style from '../inputs.module.less';
import { getLabelForGoodsType } from './label-for-goods-type';
import { dangerousGoodsDhlEcommerce } from '../../../../../../src/services/other-shipping-options/constants';
import GoodsTypeInternational from './goods-type-international';
import GoodsTypeDomestic from './goods-type-domestic';

const DangerousGoodsDHLClassification = ({ updateOption, goodsClassification, setGoodsClassification, isInternational }) => {
  const selectedGoodsDisplay = useMemo(() => {
    return getLabelForGoodsType(goodsClassification);
  }, [goodsClassification]);

  const onDomesticChange = useCallback(
    (goodsType) => {
      setGoodsClassification(goodsType);
      const newValue = {
        dangerousGoodsDhlDomestic: goodsType,
        dangerousGoodsDhlInternational: undefined,
      };
      updateOption({ id: dangerousGoodsDhlEcommerce, value: newValue });
    },
    [updateOption, setGoodsClassification],
  );
  const onIntlChange = useCallback(
    (goodsType) => {
      setGoodsClassification(goodsType);
      const newValue = {
        dangerousGoodsDhlDomestic: undefined,
        dangerousGoodsDhlInternational: goodsType,
      };
      updateOption({ id: dangerousGoodsDhlEcommerce, value: newValue });
    },
    [setGoodsClassification, updateOption],
  );

  return (
    <DropdownMenu>
      <DropdownMenuToggler className={style['bigly-dropdown']}>{selectedGoodsDisplay}</DropdownMenuToggler>
      {isInternational ? <GoodsTypeInternational onIntlChange={onIntlChange} /> : <GoodsTypeDomestic onDomesticChange={onDomesticChange} />}
    </DropdownMenu>
  );
};

DangerousGoodsDHLClassification.propTypes = {
  goodsClassification: PropTypes.string.isRequired,
  setGoodsClassification: PropTypes.func.isRequired,
  updateOption: PropTypes.func.isRequired,
  isInternational: PropTypes.bool.isRequired,
};

export default DangerousGoodsDHLClassification;
